import styled from '@olxeu-a2b/ui/src/theme/styled';
import Tick from '@nexus/lib-react/dist/core/Icon/icons/default/Tick';

const ListIconTick = styled(Tick)`
  color: ${({ theme }) => theme.colors.tealPrimary};
  display: flex;
  align-self: flex-start;
  margin-right: ${({ theme }) => theme.sizes[12]};
  height: ${({ theme }) => theme.sizes[16]};
  width: ${({ theme }) => theme.sizes[16]};
  min-width: ${({ theme }) => theme.sizes[16]};
`;

export default ListIconTick;
